import { paramsArray2Str } from '@/utils'
import { patch, read } from '@/utils/request'
import type { BatchProcessingParams, BatchProcessingRes, DetailWithLogs, ListData } from 'bv-typings'

export type IDistributeMailType = 'addressee' | 'appeal'| 'reminder' | ''

export type IMailAddresseeListParams = {
  saleName?: string[]
  saleEmail?: string[]
}

export type IMailAddresseeInfo = {
  id: string
  saleName: string
  abbreviation: string	// 缩写
  saleEmail: string	// 销售邮箱
  recipientOfBlockedAppeal: string[]	// 被封申诉收件人
  copyOfBlockedAppeal: string[]	// 被封申诉抄送人
  recipientOfRad: string[]	// Rad收件人
  copyOfRad: string[] // Rad抄送人
}

export type IMailAddresseeListRes = ListData<IMailAddresseeInfo>

async function getAddresseeList (params?: IMailAddresseeListParams) {
  return read<IMailAddresseeListRes> ('mail_distribution/recipients', params)
}

export type IEditAddresseeParams = {

} & Omit<IMailAddresseeInfo, 'saleEmail'>

async function editAddressee (params: IEditAddresseeParams, id: string) {
  return patch<any> ('mail_distribution/recipients', paramsArray2Str(params), '修改收件人失败', id)
}

async function getAddresseeDetail (id: string) {
  return read<DetailWithLogs<IMailAddresseeInfo>> ('mail_distribution/recipients', undefined, '获取收件人详情失败', id )
}

async function batchEditAddressee (params: BatchProcessingParams<IEditAddresseeParams>[]) {
  return patch<BatchProcessingRes<IEditAddresseeParams>> (
    'mail_distribution/recipients',
    params.map(item => paramsArray2Str(item)),
  )
}

export type MailSaleListItem = {
  saleName: string
  saleEmail: string
}

async function searchAddresseeSale (saleName?: string) {
  return read<MailSaleListItem[]> ('mail_distribution/recipients_search_sales', { saleName }, '获取销售（邮箱）失败' )
}

async function getAddresseeSaleList (params?: string ) {
  const [ res ] = await searchAddresseeSale(params)
  return res?.map(({ saleName, saleEmail }) => ({ value: saleEmail, title: `${ saleName }【${ saleEmail }】` }))
}

export {
  getAddresseeList,
  editAddressee,
  getAddresseeDetail,
  batchEditAddressee,
  searchAddresseeSale,
  getAddresseeSaleList,
}


